export default __webpack_public_path__ + "assets/3c0cfe0b77f7e5fe47b2bcbab8b3ddc8-templates-phone-contact.svg";